<template>
  <q-page padding>
    <div>
      <div class="row col-12 justify-between align-center">
        <p class="text-h6 text-brand-1 text-weight-bolder">
          Consulta Ficha de EPIs Legado
        </p>
      </div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2 q-ml-sm">
          Nome
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.nome"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Matricula
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.matricula"
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template #body-cell-url_assinada="props">
          <q-td>
            <q-btn
              :href="props.row.url_assinada"
              target="_blank"
              type="a"
              round
              flat
              color="brand-1"
              icon="sym_o_download"
            />
          </q-td>
        </template>
        <template #body-cell-updated_at="props">
          <q-td>
            <div>
              {{
                props.row.updated_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div class="q-pl-sm">
              {{ props.row.updated_at.split(" ")[1] }}
            </div>
          </q-td>
        </template>
        <template #body-cell-etiqueta="props">
          <q-td>
            <q-btn
              v-if="props"
              icon="sym_o_article"
              @click="imprimir(props.row.matricula)"
              flat
              round
              color="blue"
            />
          </q-td>
        </template>
      </q-table>
      <div v-if="rows.length != 0" class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "nome",
    label: "Nome Funcionário",
    field: "nome",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula Funcionário",
    field: "matricula",
    align: "left",
  },

  {
    name: "funcao",
    label: "Função",
    field: "funcao",
    align: "left",
  },
  {
    name: "dataAdmissao",
    label: "Data Admissão",
    field: (row) => row.dataAdmissao.split("-").reverse().join("/"),
    align: "left",
  },
  {
    name: "etiqueta",
    label: "Vizualizar Ficha",
    field: "etiqueta",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const router = useRouter();
    const filtros = ref({
      nome: "",
      matricula: "",
    });

    const status = ref([
      { label: "Todos", value: "" },
      { label: "Disponível", value: "disponivel" },
      { label: "Em Uso", value: "uso" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);
    const qrMobile = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 1, rowsPerPage = 15) => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("seguranca/getFichaLegado", {
          vendor_id: await store.state.org.unidadeData.id,
          pagina: page,
          per_page: rowsPerPage,
          nome_relatorio: "usuario_legado_vale",
          nome: filtros.value.nome == "" ? undefined : filtros.value.nome,
          matricula:
            filtros.value.matricula == "" ? undefined : filtros.value.matricula,
          dataInicial: "01/01/2000",
          dafaFinal: new Date().toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }),
        });

        rows.value = response.data.dados;

        pagination.value.page = response.data.paginaAtual;
        //pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const imprimir = async (matricula) => {
      router.push({
        name: "seguranca-consulta-ficha-legado-detalhe",
        params: { id: matricula },
      });
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      qrMobile,
      status,
      imprimir,
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
